export default __webpack_public_path__ + "static/media/ServerSideError.a980009b.svg";